<script setup lang="ts">
import FormCategoriaServico from '../components/form-categoriaservico.vue'
import { useCategoriaServicoStore } from '../store/useCategoriaServicoStore'

definePage({
  meta: {
    navActiveLink: 'admin-categoria-servico',
    action: 'create',
    subject: 'categoria-servico',
  },
})

const { resetForm } = useCategoriaServicoStore()

onBeforeRouteLeave(() => {
  resetForm()
})
</script>

<template>
  <FormCategoriaServico />
</template>
